<div class="bq9-review-and-sign"
     data-testid="bq9-container-review-and-sign">
  <schedule-detail-header class="bq9-review-and-sign-header"
                          title="Celebration"
                          [subtitle]="subtitle"
                          [backCallback]="goBack.bind(this)"
                          [backLabel]="'Back'"
                          [bottomBorder]="true"
                          [showCloud]="true"
                          [isRefreshingInBackground]="isRefreshingInBackground()">
  </schedule-detail-header>

  <div class="bq9-review-and-sign-content"
       [appDataUpdatedFade]="dataUpdatedPulse()"
       data-testid="bq9-container-review-and-sign-content">
    @if (dataLoaded) {
      <div class="step-indicator"
           data-testid="bq9-text-step-indicator">
        STEP {{ step() }} OF 2
      </div>
      <h1>{{ stepHeader() }}</h1>
      <div class="step-description"
           data-testid="bq9-text-step1-description">
        {{ stepDescription() }}
      </div>
      @switch (step()) {
        @case (1) {
          <div class="issues-list">
            @if (hasNoIssues()) {
              <div class="issue-item">
                <i class="pi pi-check-circle"
                   data-testid="icon-confirmed-issue"></i>
                <span> All Clear! Your home has zero outstanding issues. </span>
              </div>
            } @else {
              @if (confirmedByHomeownerIssues().length > 0) {
                <h2>Complete</h2>
                @for (issue of confirmedByHomeownerIssues(); track issue.id) {
                  <div class="issue-item">
                    <i class="pi pi-check-circle"
                       data-testid="icon-confirmed-issue"></i>
                    <div class="issue-text-wrap">
                      <span class="issue-text"
                            [class.issue-text--clamped]="!isIssueExpanded(issue.identifier)">
                        {{ issue.text }}
                      </span>
                      @if (issue.text.length > ISSUE_TEXT_READ_MORE_THRESHOLD) {
                        <button type="button"
                                class="read-more-btn"
                                (click)="toggleIssueText(issue.identifier)">
                          {{ isIssueExpanded(issue.identifier) ? 'Read less' : 'Read more' }}
                        </button>
                      }
                    </div>
                  </div>
                }
              }
              @if (followUpIssues().length > 0) {
                <h2>Follow-Up</h2>
                @for (issue of followUpIssues(); track issue.id) {
                  <div class="issue-item">
                    <img src="assets/icons/material-construction.svg"
                         alt="Follow-Up" />
                    <div class="issue-text-wrap">
                      <span class="issue-text"
                            [class.issue-text--clamped]="!isIssueExpanded(issue.identifier)">
                        {{ issue.text }}
                      </span>
                      @if (issue.text.length > ISSUE_TEXT_READ_MORE_THRESHOLD) {
                        <button type="button"
                                class="read-more-btn"
                                (click)="toggleIssueText(issue.identifier)">
                          {{ isIssueExpanded(issue.identifier) ? 'Read less' : 'Read more' }}
                        </button>
                      }
                    </div>
                  </div>
                }
              }
              @if (seasonalIssues().length > 0) {
                <h2>Seasonal</h2>
                @for (issue of seasonalIssues(); track issue.id) {
                  <div class="issue-item">
                    <img src="assets/icons/material-construction.svg"
                         alt="Seasonal" />
                    <div class="issue-text-wrap">
                      <span class="issue-text"
                            [class.issue-text--clamped]="!isIssueExpanded(issue.identifier)">
                        {{ issue.text }}
                      </span>
                      @if (issue.text.length > ISSUE_TEXT_READ_MORE_THRESHOLD) {
                        <button type="button"
                                class="read-more-btn"
                                (click)="toggleIssueText(issue.identifier)">
                          {{ isIssueExpanded(issue.identifier) ? 'Read less' : 'Read more' }}
                        </button>
                      }
                    </div>
                  </div>
                }
              }
            }
          </div>

          <form [formGroup]="signForm"
                class="signature-section">
            <div class="agreement-wrapper">
              <div class="agreement-checkbox"
                   [class.has-error]="
                  showValidationErrors() && signForm.get('agreed')?.invalid
                ">
                <p-checkbox formControlName="agreed"
                            [binary]="true"
                            inputId="agreed"></p-checkbox>
                <label for="agreed">{{ agreementTitle() }}</label>
              </div>
              <div class="agreement-description">
                {{ agreementDescription() }}
              </div>
              @if (showValidationErrors() && signForm.get("agreed")?.invalid) {
                <app-input-error class="agreement-error">
                  You must agree to the terms to proceed.
                </app-input-error>
              }
            </div>

            @if (signForm.get('agreed')?.value === true) {
              <div class="homeowner-wrapper">
                <div class="signature-description">
                  By typing your name below, you agree that it stands as your
                  official signature.
                </div>

                <div class="homeowner-group">
                  @if (showValidationErrors() && !hasAtLeastOneValidPair) {
                    <app-input-error class="validation-warning">
                      <i class="pi pi-exclamation-triangle"></i>
                      <span>At least one homeowner signature and valid email are
                        required.</span>
                    </app-input-error>
                  }
                  <h3>Homeowner 1</h3>
                  <input pInputText
                         type="text"
                         formControlName="h1Signature"
                         placeholder="Type Name to Sign"
                         class="signature-input"
                         [class.has-error]="h1SigError" />
                  <input pInputText
                         type="email"
                         formControlName="h1Email"
                         placeholder="Enter Email Address"
                         [class.has-error]="h1EmailError" />
                </div>

                <div class="homeowner-group">
                  <h3>Homeowner 2</h3>

                  @if (
                    showValidationErrors() &&
                    isPairPartial("h2Signature", "h2Email")
                  ) {
                    <app-input-error class="homeowner-group-error">
                      Both signature and valid email are required if adding a
                      second homeowner.
                    </app-input-error>
                  }

                  <input pInputText
                         type="text"
                         formControlName="h2Signature"
                         placeholder="Type Name to Sign"
                         class="signature-input"
                         [class.has-error]="h2SigError" />
                  <input pInputText
                         type="email"
                         formControlName="h2Email"
                         placeholder="Enter Email Address"
                         [class.has-error]="h2EmailError" />
                </div>

                <button type="button"
                        class="skip-signature-btn"
                        (click)="openSkipSheet()"
                        data-testid="bq9-review-and-sign-btn-skip-signature">
                  Skip Customer Signature
                </button>
              </div>
            }

            <app-skip-signature-bottom-sheet [isOpen]="showSkipSheet()"
                                             (isOpenChange)="showSkipSheet.set($event)"
                                             [isSkipMode]="didSkipSignatures()"
                                             [initialH1Email]="bq8HomeownerEmails()[0] || ''"
                                             [initialH2Email]="bq8HomeownerEmails()[1] || ''"
                                             (skipConfirmed)="onSkipConfirmed($event)"
                                             (skipCleared)="onSkipCleared()" />
          </form>
        }
        @case (2) {
          <form [formGroup]="photoForm">
            <div class="photos-section">
              @if (imageCompressionPipelineService.isLoadingImages()) {
                <p-message severity="info"
                           class="loading-images-message"
                           [class.has-photos]="allImages().length > 0"
                           data-testid="bq9-review-and-sign-images">
                  Adding
                  {{
                    imageCompressionPipelineService.numberOfImagesBeingProcessed()
                  }}
                  image...
                </p-message>
              }

              <div role="group"
                   aria-labelledby="photos-label"
                   class="photo-grid"
                   data-testid="bq9-review-and-sign-photo-grid">
                @for (image of allImages(); track $index) {
                  <button class="photo-cell"
                          type="button"
                          (click)="openImagesModal($index)"
                          [attr.data-testid]="
                      'bq9-review-and-sign-photo-thumbnail-' + $index
                    ">
                    <img [src]="image"
                         [alt]="'View photo ' + ($index + 1)" />
                  </button>
                }
              </div>

              @if (imageCompressionPipelineService.isCompressingImages()) {
                <p-message severity="info"
                           class="optimizing-images-message has-photos"
                           data-testid="bq9-review-and-sign-optimizing-images">
                  Optimizing
                  {{
                    imageCompressionPipelineService.numberOfImagesBeingProcessed()
                  }}
                  images...
                </p-message>
              }

              <div class="photos-buttons-container"
                   data-testid="bq9-review-and-sign-photo-actions">
                <button type="button"
                        class="add-photo"
                        [disabled]="
                    imageCompressionPipelineService.isCompressingImages()
                  "
                        [attr.aria-disabled]="
                    imageCompressionPipelineService.isCompressingImages()
                  "
                        (click)="triggerCamera()"
                        aria-controls="bq9-review-and-sign-camera-input"
                        data-testid="bq9-review-and-sign-btn-camera">
                  <img src="assets/icons/cameraAdd.svg"
                       alt=""
                       aria-hidden="true" />
                  <p>Camera</p>
                </button>

                <button type="button"
                        class="add-photo"
                        [disabled]="
                    imageCompressionPipelineService.isCompressingImages()
                  "
                        [attr.aria-disabled]="
                    imageCompressionPipelineService.isCompressingImages()
                  "
                        (click)="triggerGallery()"
                        aria-controls="bq9-review-and-sign-gallery-input"
                        data-testid="bq9-review-and-sign-btn-library">
                  <img src="assets/icons/photoLibrary.svg"
                       alt=""
                       aria-hidden="true" />
                  <p>Library</p>
                </button>

                <input #cameraInput
                       id="bq9-review-and-sign-camera-input"
                       type="file"
                       accept="image/*"
                       capture="environment"
                       style="display: none"
                       (change)="handleImage($event)"
                       data-testid="bq9-not-complete-input-camera-file" />

                <input #galleryInput
                       multiple
                       id="not-complete-gallery-input"
                       type="file"
                       accept="image/*"
                       style="display: none"
                       (change)="handleImage($event)"
                       data-testid="bq9-not-complete-input-gallery-file" />
              </div>
            </div>

            <div class="signature-section">
              <div class="agreement-wrapper agreement-wrapper-photos">
                <div class="agreement-checkbox">
                  <p-checkbox formControlName="agreed"
                              [binary]="true"
                              inputId="agreed"></p-checkbox>
                  <label for="agreed">{{ agreementTitle() }}</label>
                </div>
                <div class="agreement-description">
                  {{ agreementDescription() }}
                </div>
              </div>
            </div>
          </form>
        }
      }
    }
  </div>

  <div class="bq9-review-and-sign-footer"
       data-testid="bq9-review-and-sign-footer">
    @if (step() === 1) {
      <p-button label="Go to Step 2"
                styleClass="bqa-primary-btn p-fullwidth-button"
                (click)="goToStepTwo()"
                data-testid="bq9-review-and-sign-btn-step-two" />
    }
    @if (step() === 2) {
      <p-button class="back-btn"
                label="Back"
                styleClass="bqa-primary-btn p-fullwidth-button"
                (click)="goToStepOne()"
                data-testid="bq9-review-and-sign-btn-back" />
      <p-button label="Finish"
                styleClass="bqa-primary-btn p-fullwidth-button"
                (click)="submit()"
                data-testid="bq9-review-and-sign-btn-submit" />
    }
  </div>
</div>